import React from "react";
import "./Loader.css";

function Loader() {
  return (
    <div className="ticketverz-loader" role="status" aria-live="polite">
      <span className="sr-only">Loading...</span>
      <div className="ticketverz-loader__spinner" aria-hidden="true"></div>
    </div>
  );
}

export default Loader;
